import React from 'react';
import { Button } from '@atlas/ui';

import { sendPostMessage } from './bus.repeater';

export default function PostMessageActionButton(props) {
  const { message, action = 'unspecified', type = 'primary', size = 'medium' } = props;

  const sendPostMessageHandler = React.useCallback(() => sendPostMessage(action), [action]);

  return <Button type={type} size={size} label={message} onClick={sendPostMessageHandler} />;
}
